import { render } from "./patient_details.vue?vue&type=template&id=088104b4&scoped=true"
import script from "./patient_details.vue?vue&type=script&lang=js"
export * from "./patient_details.vue?vue&type=script&lang=js"

import "./patient_details.vue?vue&type=style&index=0&id=088104b4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088104b4"]])

export default __exports__